import { render } from "./widget-balance-skeleton.vue?vue&type=template&id=7505b20a&scoped=true"
import script from "./widget-balance-skeleton.vue?vue&type=script&lang=js"
export * from "./widget-balance-skeleton.vue?vue&type=script&lang=js"

import "./widget-balance-skeleton.vue?vue&type=style&index=0&id=7505b20a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7505b20a"]])

export default __exports__